export const queryParams2Object = search =>
  search
    ? JSON.parse(
        `{"${search
          .split('?')[1]
          .replace(/&/g, '","')
          .replace(/=/g, '":"')}"}`,
        (key, value) => (key === '' ? value : decodeURIComponent(value))
      )
    : {};
